// extracted by mini-css-extract-plugin
module.exports = {"CoverGallery":"styles_CoverGallery__2Bup_","fadeIn":"styles_fadeIn__NmYjY","CoverGallery-logo":"styles_CoverGallery-logo__24qvp"};